"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const select_1 = __importDefault(require("components/cosmos/select"));
const translationContext_1 = require("configs/translationContext");
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const stores_1 = require("modules/content/dripping/stores");
const types_1 = require("modules/content/dripping/types");
const featureToggle_1 = require("modules/featureToggle");
const drippingByDate_1 = __importDefault(require("./drippingByDate"));
const drippingByDays_1 = __importDefault(require("./drippingByDays"));
const drippingByQuiz_1 = __importDefault(require("./drippingByQuiz"));
const switchContainer_1 = __importDefault(require("./switchContainer"));
const mapStateToProps = (stores) => ({
    releaseDrippingType: stores.DrippingFormStore.releaseDrippingType,
    isReleaseEnabled: stores.DrippingFormStore.isReleaseEnabled,
    isDrippingByQuizEnabled: stores.FeatureToggleStore.featureToggles.get(featureToggle_1.FeatureToggles.DrippingByQuiz)
});
const ReleaseSettings = ({ releaseDrippingType, isReleaseEnabled, isDrippingByQuizEnabled }) => {
    var _a;
    const { t } = (0, translationContext_1.useTranslation)();
    const drippingTypeOptions = [
        {
            label: t('dripping_2.new.release_and_expiration.release.items.days_after_purchase.title'),
            value: String(types_1.ReleaseDrippingTypes.DaysAfter)
        },
        {
            label: t('dripping_2.new.release_and_expiration.release.items.specific_date.title'),
            value: String(types_1.ReleaseDrippingTypes.SpecificDate)
        }
    ];
    if (isDrippingByQuizEnabled) {
        drippingTypeOptions.push({
            label: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('dripping_2.new.release_and_expiration.release.items.quiz.title'), ' ', (0, jsx_runtime_1.jsx)("span", { className: "_text-gray-400 _ml-1", children: `(${(_a = t('general.beta')) === null || _a === void 0 ? void 0 : _a.toLowerCase()})` })] })),
            value: String(types_1.ReleaseDrippingTypes.Quiz)
        });
    }
    const handleSwitchChange = () => {
        stores_1.DrippingFormStore.setIsReleaseEnabled(!isReleaseEnabled);
    };
    const handleSelectChange = ({ value }) => {
        const newReleaseDrippingType = Number(value);
        stores_1.DrippingFormStore.setReleaseDrippingType(newReleaseDrippingType);
    };
    return ((0, jsx_runtime_1.jsx)(switchContainer_1.default, { id: "liberationSwitchContainer", title: t('dripping_2.new.release_and_expiration.release.description'), isChecked: isReleaseEnabled, onChange: handleSwitchChange, children: isReleaseEnabled && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(select_1.default, { id: "selectDrippingType", placeholder: `${t('general.select')}...`, label: t('dripping_2.new.release_and_expiration.release.items.label'), noResultText: t('general.no_result_found'), className: "_mb-0", labelClassName: "_text-gray-900 _mt-0 _mb-2", inputClassName: "_text-gray-900", optionClassName: "_text-gray-900", options: drippingTypeOptions, value: String(releaseDrippingType), onChange: handleSelectChange }), {
                    [types_1.ReleaseDrippingTypes.DaysAfter]: (0, jsx_runtime_1.jsx)(drippingByDays_1.default, {}),
                    [types_1.ReleaseDrippingTypes.SpecificDate]: (0, jsx_runtime_1.jsx)(drippingByDate_1.default, {}),
                    [types_1.ReleaseDrippingTypes.Quiz]: (0, jsx_runtime_1.jsx)(drippingByQuiz_1.default, {})
                }[releaseDrippingType]] })) }));
};
exports.default = (0, flowRight_1.default)((0, mobx_react_1.inject)(mapStateToProps))(ReleaseSettings);
